import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FileUploadModule } from 'ng2-file-upload';
import { FileUploadComponent } from './file-upload.component';
import {MatCardModule} from "@angular/material/card";

@NgModule({
    declarations: [FileUploadComponent],
    imports: [
        CommonModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        FileUploadModule,
        MatCardModule
    ],
    exports: [FileUploadComponent]
})
export class FileUploadUIModule { }
